module.exports = __webpack_public_path__ + "22ecdbc3ea532206b35dcfa5708f0ea2.pdf";